import { useMemo } from 'react';

import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

import { DEFAULT_QUICK_AMOUNTS, QuickButton, useUserQuickAmounts } from './use-user-quick-amounts-store';

export const useQuickAmounts = () => {
    // take the locally saved quick amounts
    const savedQuickAmounts = useUserQuickAmounts(state => state.quickAmounts);

    // take the configured quick amounts from prismic
    const prismicConfiguredQuickAmounts = useJurisdictionStore(
        store => store.jurisdictionSettings?.productConfig?.keyValuePairs?.['Quick Amounts']
    );

    // parse the values to ensure we only have integers
    const parsedPrismicQuickAmounts = prismicConfiguredQuickAmounts
        ? Object.keys(prismicConfiguredQuickAmounts).map(key => ({
              id: parseInt(key, 10),
              value: parseInt(prismicConfiguredQuickAmounts[key], 10),
          }))
        : DEFAULT_QUICK_AMOUNTS;

    // if the user has saved quick amounts, use them, otherwise use the prismic configured ones
    const chosenQuickAmounts = savedQuickAmounts.length > 0 ? savedQuickAmounts : parsedPrismicQuickAmounts;

    // if the user has saved quick amounts, we need to fill the missing values with the default ones
    const quickAmountsWithMissingValues = useMemo(() => {
        return DEFAULT_QUICK_AMOUNTS.map(
            (defaultQuickAmount, index) => chosenQuickAmounts[index] || defaultQuickAmount
        );
    }, [chosenQuickAmounts]);

    return useMemo(
        // we need to slice the array to show only 3 quick amounts
        () => quickAmountsWithMissingValues.slice(0, 3),
        [quickAmountsWithMissingValues]
    );
};

export const getQuickButtonLabel = (quickButtonData: QuickButton, mode: 'add' | 'set') => {
    if (quickButtonData.id === 'MAX') {
        return 'Max';
    }
    if (mode === 'set') {
        return `$${quickButtonData.value}`;
    }
    return `+$${quickButtonData.value}`;
};
